// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__w3qeZ","title":"Card_title__2xNoo","details":"Card_details__16bdo","stats":"Card_stats__MRf-R","image":"Card_image__3YEgo"};